import { filterFromArray } from 'library/helpers/utility';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ManageAssetGroupModal } from 'zComponents/molecules';
import { Button, Col, Empty, Flex, Input, Row, Typography } from 'zui/Antd';

const { Title } = Typography;
const { Search } = Input;

const RenderAssetsForAssetGroup = ({ group, showHeader }) => {
	// Global Data
	const { data: devicesData } = useSelector((state) => state.Devices);

	// Local States
	const [filteredAssets, setFilteredAssets] = useState([]);
	const [assets, setAssets] = useState([]);
	const [manageModalVisible, setManageModalVisible] = useState(false);

	useEffect(() => {
		if (devicesData.length > 0 && Object.keys(group).length > 0) {
			const groupAssets = group.assets.map((a) => devicesData.find((b) => a.assetID === b.uID));
			setAssets(groupAssets);
			setFilteredAssets(groupAssets);
		}
		return () => {
			setAssets([]);
			setFilteredAssets([]);
		};
	}, [devicesData, group]);

	return (
		<Row gutter={[10, 10]}>
			<Col span={24}>
				{showHeader && (
					<Flex justify='space-between' align='center'>
						<Title level={5} style={{ margin: 0 }}>
							Assets
						</Title>
						<ManageAssetGroupModal
							data={group}
							visible={manageModalVisible}
							setVisible={setManageModalVisible}
						>
							<Button size='small' onClick={() => setManageModalVisible(true)}>
								Manage
							</Button>
						</ManageAssetGroupModal>
					</Flex>
				)}
			</Col>
			<Col span={24}>
				<Search
					placeholder='Search by Name or Unique Identification Number'
					enterButton='Search'
					onChange={(event) => {
						filterFromArray(assets, event.target.value, ['name', 'uID'], setFilteredAssets);
					}}
					onSearch={(query) => {
						filterFromArray(assets, query.target.value, ['name', 'uID'], setFilteredAssets);
					}}
				/>
			</Col>

			<Col span={24}>
				{assets.length > 0 ? (
					<Row>
						{filteredAssets.map((item) => (
							<item.cardComponent key={item.uID} device={item} />
						))}
					</Row>
				) : (
					<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span>Add Assets to the Group.</span>}>
						<Button size='small' onClick={() => setManageModalVisible(true)}>
							Manage
						</Button>
					</Empty>
				)}
			</Col>
		</Row>
	);
};

export default RenderAssetsForAssetGroup;
